// İçerik sayfaları için tek kaynaklı veri katmanı.
// Kategori, sınav, seviye ve yasal sayfalar bu veriden veri-temelli üretilir.

// ---------- Kategori sayfaları ----------

export interface CategoryStep {
  title: string;
  text: string;
}

export interface CategoryArea {
  icon: string;
  title: string;
  text: string;
}

export interface CategoryRelated {
  label: string;
  href: string;
}

export interface CategoryPageData {
  slug: string;
  crumb: string;
  title: string;
  intro: string;
  audience: string[];
  steps: CategoryStep[];
  areas: CategoryArea[];
  routeNote: string;
  related: CategoryRelated[];
}

export const categories: Record<string, CategoryPageData> = {
  egitimler: {
    slug: "egitimler",
    crumb: "Eğitimler",
    title: "Video ders arşivi",
    intro:
      "Okul öncesinden üniversite ve kamu sınavlarına kadar konu anlatımı videoları. İstediğin zaman, kendi hızında izle; takıldığın yeri geri sar.",
    audience: [
      "Okul öncesi çocuklar ve velileri",
      "İlkokul ve ortaokul öğrencileri",
      "Lise öğrencileri",
      "Üniversite ve kamu sınavı adayları",
    ],
    steps: [
      { title: "Konuyu seç", text: "Sınıfına veya hedef sınavına uygun dersi bul." },
      { title: "Kısa anlatımı izle", text: "Konuyu netleştiren, odaklı bir anlatımla başla." },
      { title: "Pekiştir", text: "Alıştırma ve soru setiyle öğrendiğini hemen uygula." },
    ],
    areas: [
      { icon: "ri-vidicon-line", title: "Konu anlatımları", text: "Ders ve konuya göre kısa, odaklı videolar." },
      { icon: "ri-lightbulb-line", title: "Soru çözümleri", text: "Çözüm yaklaşımını adım adım gösteren videolar." },
      { icon: "ri-refresh-line", title: "Konu tekrarı", text: "Kaldığın yerden, tekrar ihtiyacına göre izle." },
      { icon: "ri-file-list-3-line", title: "Ders notları", text: "Videoyla birlikte gelen özet ve notlar." },
    ],
    routeNote:
      "Kişisel rotan, video dersi günün ilk adımı olarak planlar; ardından soru çözümü ve mini değerlendirme gelir.",
    related: [
      { label: "Sınıflar", href: "/siniflar" },
      { label: "Sınavlara Hazırlık", href: "/sinavlar" },
      { label: "Soru Bankası", href: "/soru-bankasi" },
      { label: "Paketler", href: "/paketler" },
    ],
  },
  "canli-dersler": {
    slug: "canli-dersler",
    crumb: "Canlı Dersler",
    title: "Canlı dersler",
    intro:
      "Öğretmeninle aynı anda çalış, aklına takılanı anında sor. Derse yetişemediğinde kaydını aç, kaçırdığın konuyu kapat.",
    audience: [
      "Etkileşimli öğrenmek isteyenler",
      "Ders sırasında soru sormak isteyenler",
      "Düzenli rehberlik arayan öğrenciler",
      "Çocuğunun ders takibini yapan veliler",
    ],
    steps: [
      { title: "Programa bak", text: "Haftalık canlı ders takviminden saatini gör." },
      { title: "Derse katıl", text: "Sohbet ve dijital tahtayla birlikte çalış." },
      { title: "Sorunu sor", text: "Takıldığın yeri ders sırasında netleştir." },
      { title: "Kaydı izle", text: "Kaçırdıysan veya tekrar etmek istersen kaydı aç." },
    ],
    areas: [
      { icon: "ri-live-line", title: "Canlı anlatım", text: "Öğretmenle eş zamanlı ders deneyimi." },
      { icon: "ri-chat-3-line", title: "Soru-cevap", text: "Ders sırasında soru sorup yanıt al." },
      { icon: "ri-record-circle-line", title: "Ders kayıtları", text: "Kaçırdığın dersi sonradan izle." },
      { icon: "ri-calendar-line", title: "Haftalık program", text: "Ders saatlerini tek yerden takip et." },
    ],
    routeNote:
      "Rota, canlı dersi haftalık çalışma programına yerleştirir; böylece bağımsız çalışma ile canlı ders birbirini tamamlar.",
    related: [
      { label: "Eğitimler", href: "/egitimler" },
      { label: "Sınavlara Hazırlık", href: "/sinavlar" },
      { label: "Soru Bankası", href: "/soru-bankasi" },
      { label: "Deneme Sınavları", href: "/deneme-sinavlari" },
    ],
  },
  "soru-bankasi": {
    slug: "soru-bankasi",
    crumb: "Soru Bankası",
    title: "Soru bankası",
    intro:
      "Ders, konu ve zorluğa göre filtreleyebileceğin soru setleri. Çöz, doğrusunu gör, takıldığın sorunun çözüm yaklaşımını öğren.",
    audience: [
      "Konu pekiştirmek isteyenler",
      "Eksik konularını kapatmak isteyenler",
      "Deneme öncesi hazırlık yapanlar",
      "Her seviyeden öğrenci",
    ],
    steps: [
      { title: "Ders ve konu seç", text: "Çalışmak istediğin alanı belirle." },
      { title: "Zorluk belirle", text: "Kolay, orta veya zor seviyeyi seç." },
      { title: "Çöz", text: "Soruları çöz, yanıtını işaretle." },
      { title: "Çözümü incele", text: "Doğru cevabı ve çözüm yaklaşımını gör." },
    ],
    areas: [
      { icon: "ri-list-check-3", title: "Konu testleri", text: "Konuya özel odaklı soru setleri." },
      { icon: "ri-speed-up-line", title: "Zorluk seviyeleri", text: "Kolaydan zora ilerleyen sorular." },
      { icon: "ri-close-circle-line", title: "Yanlış takibi", text: "Yanlışların otomatik listelenir." },
      { icon: "ri-video-line", title: "Çözümler", text: "Yazılı ve video çözüm desteği." },
    ],
    routeNote:
      "Rota, her gün sana uygun sayıda ve zorlukta soru planlar; yanlışların bir sonraki tekrarın parçası olur.",
    related: [
      { label: "Deneme Sınavları", href: "/deneme-sinavlari" },
      { label: "Sınavlara Hazırlık", href: "/sinavlar" },
      { label: "Eğitimler", href: "/egitimler" },
      { label: "Paketler", href: "/paketler" },
    ],
  },
  "deneme-sinavlari": {
    slug: "deneme-sinavlari",
    crumb: "Deneme Sınavları",
    title: "Deneme sınavları",
    intro:
      "Gerçek sınav formatına uygun denemeler ve sonuç analizi. Seviyeni ölç, ders bazlı sonucunu gör, eksiklerini planlı kapat.",
    audience: [
      "Seviyesini ölçmek isteyenler",
      "Süre yönetimini geliştirmek isteyenler",
      "Sınav öncesi prova yapmak isteyenler",
      "Gelişimini düzenli takip etmek isteyenler",
    ],
    steps: [
      { title: "Denemeyi seç", text: "Hedef sınavına uygun denemeyi bul." },
      { title: "Çöz", text: "Sınav formatında, süreye karşı çöz." },
      { title: "Sonucunu gör", text: "Doğru, yanlış, boş ve net sonuçlarını incele." },
      { title: "Analiz et", text: "Ders bazlı eksiklerini belirleyip rotana yansıt." },
    ],
    areas: [
      { icon: "ri-file-text-line", title: "Sınav formatları", text: "LGS, TYT, AYT ve diğer sınav formatları." },
      { icon: "ri-timer-line", title: "Süre yönetimi", text: "Gerçek sınav süresiyle prova." },
      { icon: "ri-bar-chart-line", title: "Net analizi", text: "Ders bazlı doğru ve net görünümü." },
      { icon: "ri-pie-chart-line", title: "Gelişim takibi", text: "Denemeler arası net değişimi." },
    ],
    routeNote:
      "Rota, denemeyi düzenli aralıklarla planlar; sonuç analizine göre sıradaki çalışma adımların yeniden belirlenir.",
    related: [
      { label: "Sınavlara Hazırlık", href: "/sinavlar" },
      { label: "Soru Bankası", href: "/soru-bankasi" },
      { label: "Sınıflar", href: "/siniflar" },
      { label: "Paketler", href: "/paketler" },
    ],
  },
  ogretmenler: {
    slug: "ogretmenler",
    crumb: "Öğretmenler",
    title: "Öğretim yaklaşımı ve rehberlik",
    intro:
      "{siteName}'de öğretim yaklaşımı, canlı ders formatı, soru çözümü ve rehberlik ilkeleri nasıl işler? İşte çalışma biçimimiz.",
    audience: [
      "Rehberli çalışmak isteyen öğrenciler",
      "Soru desteği arayanlar",
      "Çocuğunun gelişimini takip eden veliler",
      "Düzenli ilerlemek isteyen herkes",
    ],
    steps: [
      { title: "Anlat", text: "Konu, kısa ve anlaşılır bir anlatımla netleştirilir." },
      { title: "Örnekle", text: "Soru çözümü üzerinden yaklaşım gösterilir." },
      { title: "Uygulat", text: "Öğrenci benzer sorularla kendini dener." },
      { title: "Geri bildir", text: "Eksikler belirlenip sıradaki adım planlanır." },
    ],
    areas: [
      { icon: "ri-presentation-line", title: "Öğretim yaklaşımı", text: "Ezber yerine, anlamayı ve uygulamayı önceleyen akış." },
      { icon: "ri-live-line", title: "Canlı ders formatı", text: "Soru-cevap ve dijital tahtayla etkileşimli ders." },
      { icon: "ri-lightbulb-line", title: "Soru çözümü", text: "Cevabı değil, çözüm yaklaşımını öğreten anlatım." },
      { icon: "ri-compass-3-line", title: "Rehberlik ilkeleri", text: "Kişisel rota ve gelişim takibiyle yönlendirme." },
    ],
    routeNote:
      "Öğretmen desteği, kişisel rotanın bir parçasıdır: takıldığın yerde rehberlik ve soru desteği devreye girer.",
    related: [
      { label: "Canlı Dersler", href: "/canli-dersler" },
      { label: "Soru Bankası", href: "/soru-bankasi" },
      { label: "Paketler", href: "/paketler" },
      { label: "Hakkımızda", href: "/hakkimizda" },
    ],
  },
  hakkimizda: {
    slug: "hakkimizda",
    crumb: "Hakkımızda",
    title: "Hakkımızda",
    intro:
      "{siteName}, her gün ne çalışacağını bilmeni sağlayan bir öğrenme platformudur. Okul öncesinden üniversite ve kamu sınavlarına kadar tek bir akışta.",
    audience: [
      "Okul öncesi ve ilkokul dönemindeki çocuklar",
      "Ortaokul ve lise öğrencileri",
      "Üniversite ve kamu sınavı adayları",
      "Çocuğunun gelişimini takip eden veliler",
    ],
    steps: [
      { title: "Anla", text: "Sınıfına ve hedef sınavına göre nerede olduğunu belirle." },
      { title: "Planla", text: "Her gün sıradaki adımı netleştir." },
      { title: "İlerle", text: "İzle, çöz, soru sor, ölç — döngüyü sürdür." },
    ],
    areas: [
      { icon: "ri-focus-3-line", title: "Odak", text: "Karmaşık değil, sade ve planlı bir öğrenme." },
      { icon: "ri-route-line", title: "Kişisel rota", text: "Her öğrenciye göre şekillenen günlük akış." },
      { icon: "ri-shield-check-line", title: "Güven", text: "Şeffaf ve dürüst bir eğitim yaklaşımı." },
    ],
    routeNote:
      "Merkezimizde kişisel öğrenme rotası vardır: planla, öğren, çöz, destek al ve gelişimini analiz et.",
    related: [
      { label: "Yardım Merkezi", href: "/yardim" },
      { label: "İletişim", href: "/iletisim" },
      { label: "Paketler", href: "/paketler" },
      { label: "Eğitimler", href: "/egitimler" },
    ],
  },
  iletisim: {
    slug: "iletisim",
    crumb: "İletişim",
    title: "İletişim",
    intro:
      "Soruların için önce yardım merkezine ve sık sorulan sorulara göz at. Aradığın yanıtı bulamazsan doğru yere yönlendirelim.",
    audience: [
      "Platform hakkında soruları olanlar",
      "Kullanım konusunda yardım arayanlar",
      "Paketler hakkında bilgi almak isteyenler",
    ],
    steps: [
      { title: "Yardım merkezine bak", text: "En sık sorulan konular burada derlendi." },
      { title: "SSS'yi incele", text: "Kısa ve net yanıtlar için sık sorulan sorulara göz at." },
      { title: "İhtiyacını netleştir", text: "Hâlâ yanıt bulamadıysan bize yönlendirme iste." },
    ],
    areas: [
      { icon: "ri-book-read-line", title: "Yardım Merkezi", text: "Kullanım rehberleri ve sık sorulanlar." },
      { icon: "ri-questionnaire-line", title: "Sık Sorulan Sorular", text: "Hızlı yanıtlar için SSS bölümü." },
      { icon: "ri-information-line", title: "Hakkımızda", text: "{siteName}'nin yaklaşımını tanı." },
    ],
    routeNote:
      "İletişim kanalları ve doğrudan destek bilgileri, platform yayına hazır hale geldiğinde bu sayfada duyurulacaktır.",
    related: [
      { label: "Yardım Merkezi", href: "/yardim" },
      { label: "Hakkımızda", href: "/hakkimizda" },
      { label: "Paketler", href: "/paketler" },
    ],
  },
  yardim: {
    slug: "yardim",
    crumb: "Yardım",
    title: "Yardım Merkezi",
    intro:
      "Platformu kullanmaya başlarken ihtiyacın olan her şey: kişisel rota nasıl kurulur, canlı derse nasıl katılınır, soru desteği nasıl çalışır.",
    audience: [
      "Yeni kullanıcılar",
      "Rota kurmak isteyenler",
      "Canlı ders ve soru desteği hakkında bilgi almak isteyenler",
      "Veli takibi hakkında bilgi arayanlar",
    ],
    steps: [
      { title: "Seviyeni seç", text: "Sınıfını veya hedef sınavını belirle." },
      { title: "Rotanı kur", text: "Sana göre planlanan günlük akışı gör." },
      { title: "İlerle", text: "Ders, soru ve denemeyle gelişimini sürdür." },
    ],
    areas: [
      { icon: "ri-route-line", title: "Rota nasıl kurulur?", text: "Seviye seçimiyle kişisel akışın oluşturulması." },
      { icon: "ri-live-line", title: "Canlı ders", text: "Katılım, program ve ders kayıtları." },
      { icon: "ri-question-line", title: "Soru desteği", text: "Takıldığın soruyu gönderme süreci." },
      { icon: "ri-parent-line", title: "Veli takibi", text: "Çocuğunun gelişimini izleme." },
    ],
    routeNote:
      "Kişisel rota, tüm bu adımları tek bir akışta birleştirir: planla, öğren, çöz, destek al ve ölç.",
    related: [
      { label: "İletişim", href: "/iletisim" },
      { label: "Paketler", href: "/paketler" },
      { label: "Hakkımızda", href: "/hakkimizda" },
    ],
  },
};

// ---------- Sınav detayları ----------

export interface ExamSubject {
  name: string;
  icon: string;
  detail: string;
  questions?: number;
}

export interface ExamStat {
  value: string;
  label: string;
}

export interface ExamJourneyStep {
  title: string;
  text: string;
}

export interface ExamData {
  slug: string;
  shortName: string;
  fullName: string;
  group: string;
  groupLabel: string;
  description: string;
  purpose: string;
  audience: string[];
  stats: ExamStat[];
  subjects: ExamSubject[];
  journey: ExamJourneyStep[];
  strategy: string;
  routeExample: string;
}

export const exams: ExamData[] = [
  {
    slug: "lgs",
    shortName: "LGS",
    fullName: "Liselere Geçiş Sınavı",
    group: "ortaokul",
    groupLabel: "Ortaokul · 8. Sınıf",
    description:
      "8. sınıf sonunda öğrencilerin liseye yerleşmesini belirleyen merkezi sınav. Sınav puanı ve okul başarı puanı birlikte değerlendirilir.",
    purpose:
      "LGS'nin amacı, ortaokuldan liseye geçişte öğrencinin temel derslerdeki yeterliliğini ölçmek ve doğru lise tercihini yapmasını sağlamaktır. Sınav iki oturumda yapılır: ilk oturum sözel, ikinci oturum sayısal alanı kapsar. Puanın, okul başarı puanıyla birleşimi sonucunda öğrenci; Fen, Anadolu, Sosyal Bilimler veya Meslek liseleri arasından tercih yapar.",
    audience: [
      "8. sınıf öğrencileri",
      "Fen veya Anadolu lisesi hedefleyenler",
      "Düzenli deneme pratiği yapmak isteyenler",
      "Netini yükseltmek isteyenler",
    ],
    stats: [
      { value: "90", label: "toplam soru" },
      { value: "2", label: "oturum" },
      { value: "75+80 dk", label: "toplam süre" },
      { value: "8. sınıf", label: "seviye" },
    ],
    subjects: [
      { name: "Türkçe", icon: "ri-quill-pen-line", detail: "Okuma-anlama, sözcükte anlam ve dil bilgisi soruları.", questions: 20 },
      { name: "Matematik", icon: "ri-calculator-line", detail: "Cebirsel ifadeler, denklemler ve geometri.", questions: 20 },
      { name: "Fen Bilimleri", icon: "ri-flask-line", detail: "Madde, kuvvet, canlılar ve enerji konuları.", questions: 20 },
      { name: "İnkılap Tarihi", icon: "ri-landscape-line", detail: "Tarih ve Atatürkçülük konularında kavram haritaları.", questions: 10 },
      { name: "Din Kültürü", icon: "ri-bookmark-line", detail: "Temel kavramlar ve değerler konu özetleri.", questions: 10 },
      { name: "Yabancı Dil", icon: "ri-global-line", detail: "Kelime bilgisi ve okuma becerisi alıştırmaları.", questions: 10 },
    ],
    journey: [
      { title: "Seviyeni ölç", text: "İlk denemeyle başlangıç netini belirle." },
      { title: "Planla", text: "Eksik konularına göre kişisel çalışma rotanı kur." },
      { title: "Çalış", text: "Konu anlatımı ve soru setiyle her gün ilerle." },
      { title: "Dene", text: "Sözel ve sayısal denemelerle sınavı prova et." },
      { title: "Analiz et", text: "Net değişimini gör, rotanı güncelle." },
    ],
    strategy:
      "LGS'de sözel ve sayısal oturum ayrı sürelere sahiptir; denemeleri hep gerçek süreyle çözerek tempoya alış. Sözelde paragraf sorularına, sayısalda problemlere öncelik ver. Yanlış yapmanın netini düşürdüğünü unutma; emin olmadığın soruda acele etme.",
    routeExample: "Bugün: Matematik \"Cebirsel İfadeler\" + Fen Bilimleri 12 soru",
  },
  {
    slug: "tyt",
    shortName: "TYT",
    fullName: "Temel Yeterlilik Testi",
    group: "universite",
    groupLabel: "Üniversite · 1. Oturum",
    description:
      "YKS'nin ilk oturumu olan TYT, tüm üniversite adaylarının girdiği temel yeterlilik sınavıdır.",
    purpose:
      "TYT, adayın Türkçe, sosyal bilimler, temel matematik ve fen bilimlerindeki genel yeterliliğini ölçer. Okuma-anlama, yorumlama ve temel matematik becerisi ön plandadır. TYT puanı AYT'ye eklenerek lisans yerleştirmesinde etkili olur; aynı zamanda ön lisans programlarına yerleşmede tek başına belirleyicidir.",
    audience: [
      "Tüm üniversite adayları",
      "Ön lisans programı hedefleyenler",
      "Okuma ve paragraf hızını artırmak isteyenler",
      "TYT netini yükseltmek isteyenler",
    ],
    stats: [
      { value: "120", label: "toplam soru" },
      { value: "165 dk", label: "süre" },
      { value: "4", label: "ders alanı" },
      { value: "1. oturum", label: "YKS" },
    ],
    subjects: [
      { name: "Türkçe", icon: "ri-quill-pen-line", detail: "Paragraf, sözcükte anlam ve dil bilgisi soruları.", questions: 40 },
      { name: "Sosyal Bilimler", icon: "ri-earth-line", detail: "Tarih, coğrafya, felsefe ve din kültürü.", questions: 20 },
      { name: "Temel Matematik", icon: "ri-calculator-line", detail: "Temel kavramlar, problemler ve geometri.", questions: 40 },
      { name: "Fen Bilimleri", icon: "ri-flask-line", detail: "Fizik, kimya ve biyoloji temel soruları.", questions: 20 },
    ],
    journey: [
      { title: "Temelini sağlamlaştır", text: "Temel kavramları ve paragraf alışkanlığını oturt." },
      { title: "Süreye alış", text: "Her konuyu süreli soru setleriyle pekiştir." },
      { title: "Deneme çöz", text: "Düzenli TYT denemeleriyle tempoyu prova et." },
      { title: "Analiz et", text: "Yanlışlarını ders bazlı incele, eksikleri kapat." },
    ],
    strategy:
      "TYT'de soru başına düşen süre kısadır; hızlı okuma ve zaman yönetimi belirleyicidir. Türkçe paragraf ve matematik problemleri en çok zaman alır, bu yüzden bu alanlarda düzenli pratik yap. Denemelerde önce kolay soruları topla, zorları sona bırak.",
    routeExample: "Bugün: TYT Matematik \"Üslü Sayılar\" + Türkçe 15 soru",
  },
  {
    slug: "ayt",
    shortName: "AYT",
    fullName: "Alan Yeterlilik Testleri",
    group: "universite",
    groupLabel: "Üniversite · 2. Oturum",
    description:
      "YKS'nin ikinci oturumu olan AYT, adayın seçtiği alandaki bilgi derinliğini ölçer.",
    purpose:
      "AYT, sayısal, sözel ve eşit ağırlık alanlarına göre farklı testlerden oluşur ve lisans programlarına yerleşmede en belirleyici oturumdur. Alan derslerindeki bilgi düzeyi, kavrama ve problem çözme becerisi sınanır. Aday, tercih ettiği bölüme göre ilgili alan testlerine girer.",
    audience: [
      "Lisans programı hedefleyenler",
      "Sayısal alan adayları",
      "Eşit ağırlık adayları",
      "Sözel alan adayları",
    ],
    stats: [
      { value: "160", label: "soru · sayısal" },
      { value: "180 dk", label: "süre" },
      { value: "3", label: "alan seçeneği" },
      { value: "2. oturum", label: "YKS" },
    ],
    subjects: [
      { name: "Matematik", icon: "ri-calculator-line", detail: "Fonksiyonlar, limit, türev ve integral konuları." },
      { name: "Fizik", icon: "ri-planet-line", detail: "Mekanik, elektrik ve modern fizik anlatımları." },
      { name: "Kimya", icon: "ri-flask-line", detail: "Madde, tepkimeler ve organik kimya." },
      { name: "Biyoloji", icon: "ri-leaf-line", detail: "Hücre, genetik ve ekosistem konuları." },
      { name: "Türk Dili ve Edebiyatı", icon: "ri-book-open-line", detail: "Edebi akımlar, metin ve dil bilgisi." },
      { name: "Tarih", icon: "ri-landscape-line", detail: "Dönem bazlı konu anlatımı ve soru çözümü." },
      { name: "Coğrafya", icon: "ri-earth-line", detail: "Harita bilgisi ve temel coğrafya konuları." },
      { name: "Felsefe Grubu", icon: "ri-braces-line", detail: "Felsefe, mantık ve psikoloji özetleri." },
    ],
    journey: [
      { title: "Alanını seç", text: "Sayısal, eşit ağırlık veya sözel rotanı belirle." },
      { title: "Hedefini koy", text: "Hedef bölüme göre net hedefini netleştir." },
      { title: "Planla", text: "TYT ve AYT dengesini kuran günlük program oluştur." },
      { title: "Çalış", text: "Alan derslerine düzenli ve derinlemesine çalış." },
      { title: "Dene", text: "AYT denemeleriyle seviyeni ölç, analizle geliş." },
    ],
    strategy:
      "AYT derinlik ister; ezber yerine kavrayarak çalış, özellikle matematik ve fen alanlarında konuyu anlamadan soruya geçme. Alan derslerine haftalık istikrarlı zaman ayırmak, sona bırakılan yoğun çalışmadan her zaman daha etkilidir. Denemelerde alan testlerine ağırlık ver.",
    routeExample: "Bugün: AYT Matematik \"Fonksiyonlar\" + Fizik 10 soru",
  },
  {
    slug: "ydt",
    shortName: "YDT",
    fullName: "Yabancı Dil Testi",
    group: "universite",
    groupLabel: "Üniversite · Yabancı Dil",
    description:
      "Yabancı dil yeterliliğini ölçen üniversiteye giriş oturumu. İngilizce başta olmak üzere farklı dillerden girilebilir.",
    purpose:
      "YDT, dil bölümü adaylarının yabancı dil bilgisini ölçer ve YKS'nin dil puanının temelini oluşturur. Kelime bilgisi, dil bilgisi, okuma ve çeviri becerileri sınanır. Dil puanıyla Mütercim-Tercümanlık, İngilizce Öğretmenliği ve Dil Edebiyat gibi bölümler tercih edilir.",
    audience: [
      "Dil bölümü adayları",
      "Mütercim-tercümanlık hedefleyenler",
      "İngilizce öğretmenliği düşünenler",
      "Kelime ve okuma becerisini geliştirmek isteyenler",
    ],
    stats: [
      { value: "80", label: "toplam soru" },
      { value: "120 dk", label: "süre" },
      { value: "5", label: "dil seçeneği" },
      { value: "Dil", label: "YKS puan türü" },
    ],
    subjects: [
      { name: "Kelime Bilgisi", icon: "ri-sparkling-2-line", detail: "Sık kullanılan kelimeler ve eş anlamlılar." },
      { name: "Dil Bilgisi", icon: "ri-braces-line", detail: "Zamanlar, edatlar ve cümle yapısı." },
      { name: "Okuma", icon: "ri-book-open-line", detail: "Paragraf ve uzun metin anlama soruları." },
      { name: "Çeviri", icon: "ri-translate-2", detail: "Cümle tamamlama ve çeviri becerisi." },
    ],
    journey: [
      { title: "Kelime hazneni kur", text: "Günlük düzenli kelime çalışmasıyla temelini at." },
      { title: "Dil bilgisini oturt", text: "Zamanları ve yapıları örneklerle pekiştir." },
      { title: "Oku", text: "Günlük paragraf ve okuma çalışması yap." },
      { title: "Dene", text: "YDT denemeleriyle süre ve strateji geliştir." },
    ],
    strategy:
      "YDT'de en büyük fark kelime haznesidir; her gün az ama düzenli kelime çalış. Okuma sorularında önce soruyu, sonra parçayı oku; ana fikri ve bağlaçları yakala. Zaman sıkıntısı yaşamamak için uzun parçaları hızlı tarama alışkanlığı kazan.",
    routeExample: "Bugün: YDT \"Paragraf okuma\" + 15 kelime sorusu",
  },
  {
    slug: "kpss",
    shortName: "KPSS",
    fullName: "Kamu Personel Seçme Sınavı",
    group: "kamu",
    groupLabel: "Kamu · Lisans / Ön Lisans",
    description:
      "Kamu kurum ve kuruluşlarına personel seçiminde kullanılan sınav. Genel yetenek ve genel kültür alanlarını kapsar.",
    purpose:
      "KPSS, kamu kurumlarına memur alımında adayların bilgi düzeyini ölçer. Genel Yetenek (Türkçe ve Matematik) ile Genel Kültür (Tarih, Coğrafya, Vatandaşlık, Güncel Bilgiler) testlerinden oluşur. Adaylar puanlarına göre merkezi ve kurum içi atamalarda değerlendirilir.",
    audience: [
      "Kamu kurumlarında çalışmak isteyenler",
      "Lisans mezunları",
      "Ön lisans mezunları",
      "Güncel bilgi ve genel kültürünü geliştirmek isteyenler",
    ],
    stats: [
      { value: "120", label: "toplam soru" },
      { value: "130 dk", label: "süre" },
      { value: "2", label: "test grubu" },
      { value: "Lisans", label: "seviye" },
    ],
    subjects: [
      { name: "Türkçe", icon: "ri-quill-pen-line", detail: "Sözcük, cümle ve paragraf soruları.", questions: 30 },
      { name: "Matematik", icon: "ri-calculator-line", detail: "Temel matematik ve sayısal mantık.", questions: 30 },
      { name: "Tarih", icon: "ri-landscape-line", detail: "Türk ve dünya tarihi konu anlatımları.", questions: 27 },
      { name: "Coğrafya", icon: "ri-earth-line", detail: "Türkiye ve dünya coğrafyası.", questions: 18 },
      { name: "Vatandaşlık", icon: "ri-scales-3-line", detail: "Anayasa ve temel hukuk bilgisi.", questions: 9 },
      { name: "Güncel Bilgiler", icon: "ri-newspaper-line", detail: "Güncel olaylar ve gelişmeler takibi.", questions: 6 },
    ],
    journey: [
      { title: "Konuları tara", text: "Genel yetenek ve genel kültür konularını haritala." },
      { title: "Çalış", text: "Konu anlatımı ve soru setiyle düzenli ilerle." },
      { title: "Günceli takip et", text: "Güncel bilgi notlarını düzenli yenile." },
      { title: "Dene", text: "KPSS denemeleriyle süre ve netini ölç." },
    ],
    strategy:
      "KPSS'de genel kültür, neti belirleyen en önemli alandır; Tarih ve Coğrafya'ya düzenli zaman ayır. Güncel bilgiler sürekli değiştiği için sınav dönemine yakın güncellemeleri takip et. Türkçe paragraf soruları zaman alır, denemelerde hızını ayarla.",
    routeExample: "Bugün: KPSS Türkçe \"Paragraf\" + Vatandaşlık 10 soru",
  },
  {
    slug: "dgs",
    shortName: "DGS",
    fullName: "Dikey Geçiş Sınavı",
    group: "kamu",
    groupLabel: "Geçiş · Ön Lisans → Lisans",
    description:
      "Ön lisans programlarından lisans programlarına dikey geçiş için yapılan sınav. Sayısal ve sözel becerileri ölçer.",
    purpose:
      "DGS, ön lisans mezunlarının lisans programlarına geçiş yapmasını sağlayan sınavdır. Sayısal ve sözel olmak üzere iki testten oluşur; adayın analitik düşünme ve akıl yürütme becerisi ölçülür. Elde edilen puan, lisans programına geçiş ve yerleştirmede kullanılır.",
    audience: [
      "Ön lisans mezunları",
      "Lisans tamamlama hedefleyenler",
      "Sayısal mantığını geliştirmek isteyenler",
      "Kariyerine lisans diploması eklemek isteyenler",
    ],
    stats: [
      { value: "100", label: "toplam soru" },
      { value: "150 dk", label: "süre" },
      { value: "2", label: "test" },
      { value: "Sayısal+Sözel", label: "içerik" },
    ],
    subjects: [
      { name: "Sayısal", icon: "ri-calculator-line", detail: "Temel matematik ve sayısal akıl yürütme.", questions: 50 },
      { name: "Sözel", icon: "ri-quill-pen-line", detail: "Sözel akıl yürütme ve paragraf soruları.", questions: 50 },
      { name: "Sayısal Mantık", icon: "ri-puzzle-line", detail: "Şekil, sayı ve tablo yorumlama soruları." },
      { name: "Sözel Mantık", icon: "ri-chat-check-line", detail: "Öncüllere dayalı çıkarım soruları." },
    ],
    journey: [
      { title: "Mantığı güçlendir", text: "Sayısal ve sözel mantık temelini oturt." },
      { title: "Temel konuları tara", text: "Matematik ve Türkçe temellerini pekiştir." },
      { title: "Soru çöz", text: "Mantık ağırlıklı soru setleriyle pratik yap." },
      { title: "Dene", text: "DGS denemeleriyle süre yönetimini geliştir." },
    ],
    strategy:
      "DGS'de soruların çoğu akıl yürütme odaklıdır; ezber değil, bol soru pratiği kazandırır. Sayısal mantık sorularında şekil ve tablo yorumlamaya özel zaman ayır. Süre baskısı yüksektir, denemelerde hangi soru türüne önce gireceğini netleştir.",
    routeExample: "Bugün: DGS \"Sayısal Mantık\" + 12 soru",
  },
  {
    slug: "ales",
    shortName: "ALES",
    fullName: "Akademik Personel ve Lisansüstü Eğitimi Giriş Sınavı",
    group: "kamu",
    groupLabel: "Akademik · Lisansüstü",
    description:
      "Lisansüstü eğitime başvuru ve akademik personel alımında kullanılan sınav. Sözel ve sayısal yeterliliği ölçer.",
    purpose:
      "ALES, yüksek lisans ve doktora programlarına başvuruda ve akademik kadro alımlarında kullanılan puanı üretir. Sözel ve sayısal iki bölümden oluşur; adayın okuduğunu anlama, analitik düşünme ve problem çözme becerisini ölçer.",
    audience: [
      "Yüksek lisans yapmak isteyenler",
      "Doktora programına başvuracaklar",
      "Akademik kadro hedefleyenler",
      "Analitik becerisini geliştirmek isteyenler",
    ],
    stats: [
      { value: "100", label: "toplam soru" },
      { value: "150 dk", label: "süre" },
      { value: "2", label: "bölüm" },
      { value: "3 yıl", label: "puan geçerliliği" },
    ],
    subjects: [
      { name: "Sözel", icon: "ri-quill-pen-line", detail: "Sözel akıl yürütme ve paragraf anlama.", questions: 50 },
      { name: "Sayısal", icon: "ri-calculator-line", detail: "Sayısal akıl yürütme ve problem çözme.", questions: 50 },
      { name: "Mantıksal Çıkarım", icon: "ri-chat-check-line", detail: "Öncüllerden sonuç çıkarma soruları." },
      { name: "Veri Yorumlama", icon: "ri-pie-chart-line", detail: "Tablo ve grafik okuma soruları." },
    ],
    journey: [
      { title: "Temeli oturt", text: "Sözel ve sayısal temel konuları pekiştir." },
      { title: "Mantık çalış", text: "Mantıksal çıkarım ve veri yorumlama pratiği yap." },
      { title: "Soru çöz", text: "ALES formatında soru setleriyle ilerle." },
      { title: "Dene", text: "Denemelerle süre ve netini ölç." },
    ],
    strategy:
      "ALES tamamen akıl yürütme ve yorumlama sınavıdır; konu ezberlemek yerine farklı soru tiplerine alış. Özellikle mantıksal çıkarım ve veri yorumlama sorularında düzenli pratik büyük fark yaratır. Puan geçerliliği sınırlı olduğu için başvuru dönemine göre planlama yap.",
    routeExample: "Bugün: ALES \"Sayısal Yetenek\" + Sözel 10 soru",
  },
  {
    slug: "yds",
    shortName: "YDS",
    fullName: "Yabancı Dil Bilgisi Seviye Tespit Sınavı",
    group: "dil",
    groupLabel: "Yabancı Dil · Seviye Tespit",
    description:
      "Yabancı dil bilgisini ölçen sınav. Kamu personeli alımı, lisansüstü eğitim ve akademik kadro başvurularında kullanılır.",
    purpose:
      "YDS, adayların yabancı dil bilgisini ölçmek için yapılan merkezi sınavdır. Kelime bilgisi, dil bilgisi, okuma ve çeviri becerileri sınanır. YDS puanı; doçentlik, doktora başvurusu, kamu personeli alımı ve dil tazminatı gibi birçok alanda kullanılır.",
    audience: [
      "Lisansüstü eğitim adayları",
      "Akademik kadro hedefleyenler",
      "Kamu personeli adayları",
      "Dil tazminatı almak isteyenler",
    ],
    stats: [
      { value: "80", label: "toplam soru" },
      { value: "180 dk", label: "süre" },
      { value: "100", label: "üzerinden puan" },
      { value: "5 yıl", label: "puan geçerliliği" },
    ],
    subjects: [
      { name: "Kelime Bilgisi", icon: "ri-sparkling-2-line", detail: "İleri düzey kelime ve eş anlamlılar." },
      { name: "Dil Bilgisi", icon: "ri-braces-line", detail: "İleri dil bilgisi ve cümle yapısı." },
      { name: "Okuma", icon: "ri-book-open-line", detail: "Uzun akademik metin anlama." },
      { name: "Çeviri", icon: "ri-translate-2", detail: "Cümle tamamlama ve çeviri becerisi." },
    ],
    journey: [
      { title: "Kelime hazneni genişlet", text: "Akademik kelime listeleriyle düzenli çalış." },
      { title: "Dil bilgisini derinleştir", text: "İleri yapıları örneklerle pekiştir." },
      { title: "Oku", text: "Akademik metinlerle okuma hızını artır." },
      { title: "Dene", text: "YDS denemeleriyle puanını ölç." },
    ],
    strategy:
      "YDS kelime ağırlıklı bir sınavdır; ileri düzey kelime bilgisi puanı doğrudan etkiler. Okuma bölümünde akademik metinlere alışmak için düzenli makale okuma yap. Süre geniş görünse de uzun metinler zaman alır; paragrafı hızlı tarama alışkanlığı kazan.",
    routeExample: "Bugün: YDS \"Dil Bilgisi\" + 15 kelime sorusu",
  },
  {
    slug: "yokdil",
    shortName: "YÖKDİL",
    fullName: "Yükseköğretim Kurumları Yabancı Dil Sınavı",
    group: "dil",
    groupLabel: "Yabancı Dil · Akademik",
    description:
      "Yükseköğretim kurumlarının yabancı dil sınavı. Akademik kadro ve lisansüstü başvurularda kullanılır.",
    purpose:
      "YÖKDİL, yükseköğretim kurumlarında akademik kadro başvuruları ve lisansüstü eğitim için kullanılan yabancı dil sınavıdır. Alan bazlı (sosyal, fen, sağlık) metinler üzerinden kelime, dil bilgisi ve okuma becerisi ölçülür.",
    audience: [
      "Akademik kadro başvurusu yapanlar",
      "Lisansüstü eğitim adayları",
      "Alan bazlı dil puanı isteyenler",
      "Sağlık ve fen bilimleri akademisyen adayları",
    ],
    stats: [
      { value: "80", label: "toplam soru" },
      { value: "180 dk", label: "süre" },
      { value: "3", label: "alan seçeneği" },
      { value: "5 yıl", label: "puan geçerliliği" },
    ],
    subjects: [
      { name: "Kelime Bilgisi", icon: "ri-sparkling-2-line", detail: "Akademik ve alan bazlı kelimeler." },
      { name: "Dil Bilgisi", icon: "ri-braces-line", detail: "Akademik dil bilgisi ve cümle yapısı." },
      { name: "Okuma", icon: "ri-book-open-line", detail: "Alan metinlerini okuma ve anlama." },
      { name: "Çeviri", icon: "ri-translate-2", detail: "Akademik cümle çevirisi." },
    ],
    journey: [
      { title: "Alanını seç", text: "Sosyal, fen veya sağlık alanına göre odaklan." },
      { title: "Kelime çalış", text: "Alanına özgü kelimeleri düzenli öğren." },
      { title: "Oku", text: "Alanına uygun akademik metinlerle çalış." },
      { title: "Dene", text: "YÖKDİL denemeleriyle puanını ölç." },
    ],
    strategy:
      "YÖKDİL alan bazlı olduğu için metinler seçtiğin alandan gelir; kendi alanının terminolojisine hâkim ol. Kelime ve okuma soruları ağırlıklıdır, bu yüzden düzenli okuma alışkanlığı kazan. Sınavı alan seçimine göre planla, doğru alandan girmek puanı olumlu etkiler.",
    routeExample: "Bugün: YÖKDİL \"Okuma\" + 12 kelime sorusu",
  },
];

// ---------- Eğitim seviyesi detayları ----------

export interface LevelFeature {
  icon: string;
  title: string;
  text: string;
}

export interface LevelSubject {
  name: string;
  icon: string;
  detail: string;
}

export interface LevelStep {
  title: string;
  text: string;
}

export interface LevelStat {
  value: string;
  label: string;
}

export interface LevelData {
  slug: string;
  name: string;
  shortName: string;
  heroEyebrow: string;
  title: string;
  subtitle: string;
  description: string;
  heroImage: string;
  audience: string[];
  features: LevelFeature[];
  subjects: string[];
  subjectDetails: LevelSubject[];
  journey: LevelStep[];
  weeklyProgram: string[];
  insightTitle: string;
  insight: string;
  stats: LevelStat[];
  ctaTitle: string;
}

export const levels: LevelData[] = [
  {
    slug: "okul-oncesi",
    name: "Okul Öncesi",
    shortName: "3–6 Yaş",
    heroEyebrow: "Okul Öncesi",
    title: "Oyunla ve merakla ilk adımlar",
    subtitle:
      "Çocuğunun dünyayı keşfetme coşkusunu, öğrenmenin ilk kıvılcımına dönüştür.",
    description:
      "Harfler, sayılar, şekiller ve renkler; kısa eğitici videolar, şarkılar ve sesli etkinliklerle çocuğunun kendi hızında ilerler. Ekran süresi kısa, öğrenme keyifli; her adım veli eşliğinde güvenli.",
    heroImage:
      "https://readdy.ai/api/search-image?query=Cheerful%20storybook%20style%20illustration%20of%20a%20colorful%20childrens%20learning%20world%20with%20friendly%20smiling%20alphabet%20letters%2C%20counting%20blocks%2C%20bright%20shapes%20and%20rainbow%20colors%20floating%20playfully%20on%20a%20soft%20cream%20pastel%20background%2C%20warm%20and%20joyful%2C%20flat%20modern%20vector%20illustration%20with%20gentle%20rounded%20forms%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=900&seq=level-okul-oncesi&orientation=squarish",
    audience: [
      "3–6 yaş arası çocuklar",
      "Okul öncesi velileri",
      "Anaokulu ve kreş öğretmenleri",
      "İlkokula hazırlık yapan aileler",
    ],
    features: [
      {
        icon: "ri-gamepad-line",
        title: "Oyun temelli öğrenme",
        text: "Harfler ve sayılar, oyunlar ve hikâyeler içinde doğal yolla kavranır.",
      },
      {
        icon: "ri-volume-up-line",
        title: "Sesli etkinlikler",
        text: "Sesli anlatımlar ve şarkılar, okuma öncesi kulak dolgunluğu sağlar.",
      },
      {
        icon: "ri-parent-line",
        title: "Veli eşliğinde",
        text: "Her etkinlik, velinin çocuğuyla birlikte keyifle uygulayacağı biçimde tasarlandı.",
      },
      {
        icon: "ri-timer-line",
        title: "Kısa ve odaklı",
        text: "15 dakikalık seanslar, çocuğun ilgisini ve dikkatini taze tutar.",
      },
    ],
    subjects: ["Harfler", "Sayılar", "Şekiller", "Renkler", "Kavramlar"],
    subjectDetails: [
      { name: "Harfler", icon: "ri-font-size", detail: "Sesleri tanıma, çizgi çalışmaları ve ilk okuma hazırlığı." },
      { name: "Sayılar", icon: "ri-hashtag", detail: "1'den 10'a sayma, miktar kavramı ve basit eşleştirme." },
      { name: "Şekiller ve Renkler", icon: "ri-shapes-line", detail: "Temel geometrik şekiller ve renkleri ayırt etme oyunları." },
      { name: "Kavramlar", icon: "ri-lightbulb-line", detail: "Büyük-küçük, alt-üst, az-çok gibi temel kavramlar." },
    ],
    journey: [
      { title: "Merak et", text: "Çocuğun ilgisini çeken bir konuyu birlikte seçin." },
      { title: "Tanı", text: "Kısa video ve sesli anlatımla yeni kavramı tanıştırın." },
      { title: "Oyna", text: "Eğlenceli etkinliklerle öğrenilen kavramı pekiştirin." },
      { title: "Tekrar et", text: "Ertesi gün kısa bir tekrarla kalıcılığı sağlayın." },
    ],
    weeklyProgram: [
      "Pazartesi — Harfler: 'A' sesini tanı",
      "Salı — Sayılar: 1'den 5'e sayma oyunu",
      "Çarşamba — Şekiller: Daire ve kare avı",
      "Perşembe — Renkler: Renk eşleştirme etkinliği",
      "Cuma — Kavramlar: Büyük-küçük oyunu",
    ],
    insightTitle: "Veli rehberi",
    insight:
      "Okul öncesi dönemde amaç 'öğretmek' değil, merakı korumak ve öğrenme sevgisini yeşertmektir. Bu yüzden etkinlikler zorlamadan, oyun havasında akar. Çocuğunuz isteksizse zorlamayın; aynı konuya farklı bir oyunla dönün.",
    stats: [
      { value: "15 dk", label: "günlük seans süresi" },
      { value: "100+", label: "oyun ve etkinlik" },
      { value: "5", label: "temel gelişim alanı" },
      { value: "0", label: "reklam ve dikkat dağıtıcı" },
    ],
    ctaTitle: "Çocuğunun ilk öğrenme yolculuğu bugün başlasın.",
  },
  {
    slug: "ilkokul",
    name: "İlkokul",
    shortName: "1–4. Sınıf",
    heroEyebrow: "İlkokul",
    title: "Sağlam bir temel, güvenli bir başlangıç",
    subtitle:
      "Okuma-yazmadan temel matematiğe; okul başarısının ilk taşlarını birlikte döşeyelim.",
    description:
      "1. sınıftan 4. sınıfa, temel konu özetleri, alıştırmalar ve mini testlerle okul başarısını destekler. Ödev desteği ve düzenli tekrarla çocuğuna öğrenme özgüveni kazandırır.",
    heroImage:
      "https://readdy.ai/api/search-image?query=Bright%20welcoming%20flat%20illustration%20of%20a%20primary%20school%20learning%20scene%20with%20open%20storybooks%2C%20colorful%20pencils%2C%20wooden%20counting%20beads%20and%20a%20friendly%20chalkboard%2C%20soft%20warm%20cream%20background%20with%20subtle%20geometric%20shapes%2C%20cheerful%20and%20trustworthy%20mood%2C%20modern%20vector%20style%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=900&seq=level-ilkokul&orientation=squarish",
    audience: [
      "İlkokul öğrencileri",
      "1–4. sınıf velileri",
      "Okuma-yazma desteği arayan aileler",
      "Okul başarısını yükseltmek isteyenler",
    ],
    features: [
      {
        icon: "ri-book-open-line",
        title: "Okuma-yazma yolculuğu",
        text: "Harf, hece, kelime ve cümle; okuma akıcılığına kadar adım adım ilerler.",
      },
      {
        icon: "ri-home-smile-line",
        title: "Ödev desteği",
        text: "Okul ödevlerine uyumlu anlatımlar, akşamları güvenle çözüm sağlar.",
      },
      {
        icon: "ri-medal-line",
        title: "Ödüllü ilerleme",
        text: "Tamamlanan her adımda rozet ve övgüyle motivasyon taze tutulur.",
      },
      {
        icon: "ri-shield-check-line",
        title: "Güvenli içerik",
        text: "Sınıfına göre seçilen konu özetleri ve açıklamalı alıştırmalar.",
      },
    ],
    subjects: ["Türkçe", "Matematik", "Hayat Bilgisi", "Fen Bilimleri", "İngilizce"],
    subjectDetails: [
      { name: "Türkçe", icon: "ri-quill-pen-line", detail: "Okuma, yazma, dil bilgisi ve anlama becerileri." },
      { name: "Matematik", icon: "ri-calculator-line", detail: "Dört işlem, problem çözme ve geometrik şekiller." },
      { name: "Hayat Bilgisi", icon: "ri-plant-line", detail: "Aile, doğa, sağlık ve toplumsal değerler." },
      { name: "Fen Bilimleri", icon: "ri-flask-line", detail: "Canlılar, madde ve dünya gözlem deneyleri." },
      { name: "İngilizce", icon: "ri-global-line", detail: "Temel kelimeler ve eğlenceli ilk diyaloglar." },
    ],
    journey: [
      { title: "Tanı", text: "Konuyu kısa ve anlaşılır bir anlatımla öğren." },
      { title: "Anla", text: "Örneklerle kavramı zihninde netleştir." },
      { title: "Uygula", text: "Alıştırmalarla öğrendiğini hemen dene." },
      { title: "Pekiştir", text: "Mini testle kalıcılığı sağla ve rozetini kazan." },
    ],
    weeklyProgram: [
      "Pazartesi — Türkçe: Hece bilgisi + 8 alıştırma",
      "Salı — Matematik: Toplama problemleri",
      "Çarşamba — Fen: Canlılar ve yaşam alanları",
      "Perşembe — Türkçe: Okuduğunu anlama testi",
      "Cuma — Hayat Bilgisi: Ailem ve ben",
    ],
    insightTitle: "Velilere not",
    insight:
      "İlkokulda en değerli kazanım bilgi değil, düzenli çalışma alışkanlığıdır. Kısa ama istikrarlı günlük çalışma, uzun ve yorucu seanslardan çok daha etkilidir. Çocuğunuzu sonuçtan çok çabaya göre övün; özgüven böyle büyür.",
    stats: [
      { value: "20 dk", label: "ideal günlük çalışma" },
      { value: "5", label: "ders alanı" },
      { value: "4", label: "sınıf seviyesi desteği" },
      { value: "Adım adım", label: "temel beceri çalışmaları" },
    ],
    ctaTitle: "Çocuğunun temelini bugün birlikte sağlamlaştıralım.",
  },
  {
    slug: "ortaokul",
    name: "Ortaokul / LGS",
    shortName: "5–8. Sınıf · LGS",
    heroEyebrow: "Ortaokul / LGS",
    title: "Okul derslerinden LGS hedefine",
    subtitle:
      "5. sınıftan 8. sınıfa müfredat takibi; LGS yaklaştıkça deneme ve net analizi öne çıkar.",
    description:
      "Sınıfına uygun temel çalışmalarla başla; 8. sınıfta LGS hedefini belirle. Ders bazlı net takibi, deneme analizi ve eksik konu tespitiyle hedefe adım adım ilerlersin.",
    heroImage:
      "https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20a%20focused%20middle%20school%20student%20with%20books%20and%20a%20digital%20tablet%2C%20surrounded%20by%20subtle%20progress%20charts%2C%20rising%20graph%20lines%20and%20target%20icons%20on%20a%20calm%20cream%20background%2C%20confident%20study%20atmosphere%2C%20clean%20geometric%20vector%20style%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=900&seq=level-ortaokul&orientation=squarish",
    audience: [
      "Ortaokul öğrencileri",
      "LGS adayları",
      "Netini yükseltmek isteyenler",
      "Düzenli çalışma programı arayanlar",
    ],
    features: [
      {
        icon: "ri-line-chart-line",
        title: "Ders bazlı net takibi",
        text: "Her denemede netini gör, gelişimini grafikle izle.",
      },
      {
        icon: "ri-file-text-line",
        title: "Gerçek LGS formatı",
        text: "Sınavla aynı süre ve soru dağılımında denemeler çöz.",
      },
      {
        icon: "ri-alert-line",
        title: "Eksik konu tespiti",
        text: "Yanlışların, eksik konularını otomatik belirler ve tekrar planlar.",
      },
      {
        icon: "ri-calendar-check-line",
        title: "Çalışma programı",
        text: "Her gün ne çalışacağını bil; planlı ve stressiz ilerle.",
      },
    ],
    subjects: ["Türkçe", "Matematik", "Fen Bilimleri", "İnkılap Tarihi", "Din Kültürü", "İngilizce"],
    subjectDetails: [
      { name: "Türkçe", icon: "ri-quill-pen-line", detail: "Paragraf, sözcükte anlam ve dil bilgisi soruları." },
      { name: "Matematik", icon: "ri-calculator-line", detail: "Cebirsel ifadeler, denklemler ve geometri." },
      { name: "Fen Bilimleri", icon: "ri-flask-line", detail: "Madde, kuvvet, canlılar ve enerji konuları." },
      { name: "İnkılap Tarihi", icon: "ri-landscape-line", detail: "Tarih ve inkılap konularında kavram haritaları." },
      { name: "Din Kültürü", icon: "ri-bookmark-line", detail: "Temel kavramlar ve değerler konu özetleri." },
      { name: "İngilizce", icon: "ri-global-line", detail: "Kelime bilgisi ve okuma becerisi alıştırmaları." },
    ],
    journey: [
      { title: "Seviyeni ölç", text: "İlk denemeyle başlangıç netini belirle." },
      { title: "Planla", text: "Eksik konularına göre kişisel çalışma rotanı kur." },
      { title: "Çalış", text: "Konu anlatımı ve soru setiyle her gün ilerle." },
      { title: "Dene", text: "Düzenli denemelerle sınavı prova et." },
      { title: "Analiz et", text: "Net değişimini gör, rotanı güncelle." },
    ],
    weeklyProgram: [
      "Pazartesi — Matematik: Cebirsel ifadeler + 12 soru",
      "Salı — Türkçe: Paragraf çözümü + 15 soru",
      "Çarşamba — Fen: Madde ve endüstri tekrarı",
      "Perşembe — İngilizce: Kelime çalışması",
      "Cuma — LGS denemesi + analiz",
    ],
    insightTitle: "LGS stratejisi",
    insight:
      "LGS'de başarı, bilgi kadar süre yönetimi ve doğru soru sıralamasıyla da ilgilidir. Önce emin olduğun soruları çöz, zor soruları sona bırak. Denemeleri hep gerçek süreyle çözerek sınav temposuna alış; net analizi, hangi konuya öncelik vereceğini netleştirir.",
    stats: [
      { value: "6", label: "ders alanı" },
      { value: "90", label: "soru · LGS formatı" },
      { value: "4", label: "sınıf seviyesi desteği" },
      { value: "∞", label: "deneme ve analiz" },
    ],
    ctaTitle: "LGS hedefine bugün planlı bir başlangıç yap.",
  },
  {
    slug: "lise",
    name: "Lise / TYT-AYT",
    shortName: "9–12. Sınıf · TYT-AYT",
    heroEyebrow: "Lise / TYT-AYT",
    title: "Üniversite hedefine odaklı yol",
    subtitle:
      "9. sınıftan 12. sınıfa müfredat desteği; TYT ve AYT için ders bazlı çalışma ve deneme analizi.",
    description:
      "Alan seçimine göre şekillenen kişisel rota, TYT-AYT denemeleri ve net takibiyle üniversite hedefine giden yolu netleştirir. Hedefin belli, yolun net; gerisi düzenli çalışma.",
    heroImage:
      "https://readdy.ai/api/search-image?query=Modern%20flat%20illustration%20of%20an%20ambitious%20high%20school%20student%20with%20a%20graduation%20cap%2C%20a%20university%20campus%20skyline%20and%20a%20winding%20career%20roadmap%20with%20milestone%20flags%20in%20the%20background%2C%20optimistic%20and%20professional%20tone%2C%20clean%20geometric%20vector%20style%20on%20a%20soft%20cream%20background%2C%20high%20detail%2C%20harmonious%20composition&width=900&height=900&seq=level-lise&orientation=squarish",
    audience: [
      "Lise öğrencileri",
      "TYT-AYT adayları",
      "Alan seçimi yapanlar",
      "Üniversite hedefi olanlar",
    ],
    features: [
      {
        icon: "ri-compass-3-line",
        title: "Alan bazlı rota",
        text: "Sayısal, eşit ağırlık veya sözel; seçtiğin alana göre planlanır.",
      },
      {
        icon: "ri-bar-chart-2-line",
        title: "TYT-AYT net takibi",
        text: "Her iki oturumun netini ayrı ayrı izle, gelişimini gör.",
      },
      {
        icon: "ri-focus-3-line",
        title: "Hedef ve sıralama",
        text: "Hedef bölüme göre net ve sıralama hedefini netleştir.",
      },
      {
        icon: "ri-time-line",
        title: "Deneme analizi",
        text: "Konu bazlı hata analiziyle çalışma önceliğini belirle.",
      },
    ],
    subjects: ["Türkçe", "Matematik", "Fizik", "Kimya", "Biyoloji", "Tarih", "Coğrafya", "Felsefe"],
    subjectDetails: [
      { name: "Matematik", icon: "ri-calculator-line", detail: "Fonksiyonlar, limit, türev ve integral konuları." },
      { name: "Fizik", icon: "ri-planet-line", detail: "Mekanik, elektrik ve modern fizik anlatımları." },
      { name: "Kimya", icon: "ri-flask-line", detail: "Madde, tepkimeler ve organik kimya." },
      { name: "Biyoloji", icon: "ri-leaf-line", detail: "Hücre, genetik ve ekosistem konuları." },
      { name: "Türkçe", icon: "ri-quill-pen-line", detail: "Paragraf ve dil bilgisi soru teknikleri." },
      { name: "Tarih", icon: "ri-landscape-line", detail: "Dönem bazlı konu anlatımı ve soru çözümü." },
      { name: "Coğrafya", icon: "ri-earth-line", detail: "Harita bilgisi ve temel coğrafya konuları." },
      { name: "Felsefe", icon: "ri-braces-line", detail: "Felsefe ve mantık konu özetleri." },
    ],
    journey: [
      { title: "Alanını seç", text: "Sayısal, eşit ağırlık veya sözel rotanı belirle." },
      { title: "Hedefini koy", text: "Hedef bölümüne göre net hedefini netleştir." },
      { title: "Planla", text: "TYT ve AYT dengesini kuran günlük program oluştur." },
      { title: "Çalış", text: "Konu anlatımı ve soru setiyle düzenli ilerle." },
      { title: "Dene", text: "Denemelerle seviyeni ölç, analizle geliş." },
    ],
    weeklyProgram: [
      "Pazartesi — AYT Matematik: Fonksiyonlar",
      "Salı — TYT Türkçe: Paragraf + 15 soru",
      "Çarşamba — AYT Fizik: Mekanik tekrarı",
      "Perşembe — TYT Matematik: Problemler",
      "Cuma — TYT-AYT denemesi + analiz",
    ],
    insightTitle: "TYT-AYT yol haritası",
    insight:
      "TYT genel yeterliliği, AYT ise alan derinliğini ölçer. İlk yıllarda temel bilgiyi sağlamlaştır, son sınıfta deneme ve analize ağırlık ver. Alan derslerine haftalık istikrarlı zaman ayırmak, sona bırakılan yoğun çalışmadan her zaman daha etkilidir.",
    stats: [
      { value: "2", label: "oturum · TYT + AYT" },
      { value: "8", label: "ders alanı" },
      { value: "3", label: "alan seçeneği" },
      { value: "4", label: "sınıf seviyesi desteği" },
    ],
    ctaTitle: "Üniversite hedefine giden yola bugün çık.",
  },
];

// ---------- Yasal sayfalar ----------

export interface LegalSection {
  heading: string;
  paragraphs: string[];
}

export interface LegalPageData {
  slug: string;
  title: string;
  sections: LegalSection[];
}

export const legalPages: LegalPageData[] = [
{
  "slug": "kvkk",
  "title": "KVKK Aydınlatma Metni",
  "sections": [
    {
      "heading": "1. Veri sorumlusu ve metnin kapsamı",
      "paragraphs": [
        "Bu metin; DersDinle.com web sitesi, DersDinle Mobil, Meraklı Masaüstü, Meraklı Mobil ve DersDinle Toplantı kapsamında kişisel verilerin hangi işlemlerde kullanıldığını açıklar. Hesabın öğrenci, veli, öğretmen veya yönetici olması ve kullanılan özellikler, işlenen verileri ve erişim kapsamını değiştirir.",
        "Bu yayında DersDinle.com marka adı kullanılmaktadır. Veri sorumlusunun gerçek kişi veya tüzel kişi kimliği, resmî adresi ve resmî başvuru kanalı henüz tamamlanmamıştır. Marka adı, kanunun aradığı veri sorumlusu kimliğinin yerine geçmez. Test yayını bu bilgileri tamamlama ve kişisel verileri hukuka uygun işleme yükümlülüğünü kaldırmaz."
      ]
    },
    {
      "heading": "2. Üyelik ve hesap işlemleri",
      "paragraphs": [
        "Kayıt ve profil ekranlarında ad soyad, e-posta, telefon, il, hesap rolü; öğrenciler için sınıf ve doğum tarihi gibi bilgiler alınır. Giriş ve hesap güvenliği için kimlik doğrulama bilgileri, oturum belirteçleri ve ilgili teknik kayıtlar kullanılır. Amaç, hesabı oluşturmak, kullanıcıyı tanımak ve yetkili olduğu hizmeti sunmaktır.",
        "Hizmetin kurulması ve yürütülmesi için zorunlu olan hesap verileri, ilgili sözleşmenin kurulması veya ifası hukuki sebebi kapsamında değerlendirilir. Gerekli olmayan veri alanları ya da farklı amaçlar bu sebebe kendiliğinden dahil değildir."
      ]
    },
    {
      "heading": "3. Ders çalışmaları, öğrenci–veli ve öğretmen ilişkisi",
      "paragraphs": [
        "Kullanılan hizmete göre seçilen ders ve konu, soru yanıtları, sonuçlar, çalışma geçmişi, görevler ve ders başlangıç/bitiş olayları işlenir. Bu kayıtlar çalışma sürecini sunmak ve geçmişi göstermek için kullanılır. Eşleştirilmiş veli ve atanmış öğretmen, yalnızca yetkili olduğu öğrencinin ilgili kayıtlarına erişebilmelidir.",
        "Veli bağlantısı açılan Meraklı cihazlarında cihaz adı, bağlantı durumu, çalışılan konu, Meraklı konuşmaları ve izin verilen uygulama kullanım kayıtları paylaşılabilir. Mobil uygulama, bu özellik kapsamında diğer uygulamaların özel mesajlarını veya ekran görüntülerini toplamaz. Cihaz ve işletim sistemi izinleri ilgili özellik ekranlarından yönetilir. İzin verilmesi, hukuken gereken ayrı açık rızanın yerine geçtiği anlamına gelmez."
      ]
    },
    {
      "heading": "4. Yerel ders hafızası, yapay zekâ ve ses",
      "paragraphs": [
        "Meraklı Mobil’de yüklü veya içe aktarılan ders paketleri ve yerel sohbet geçmişi cihazda saklanır. Yerel konu eşleştirmesi ve kayıtlı tahta adımları için çevrimiçi öğretmene soru gönderilmez. Uygun çevrimdışı Türkçe ses motoru kullanıldığında bu anlatım cihazdan seslendirilir. Veli paylaşımı veya ders bildirimi açık olduğunda ilgili etkinlik kayıtları ayrıca sunucuya iletilebilir.",
        "Yerelde eşleşmeyen soruların çevrimiçi öğretmene gönderilmesinde soru metni, sınıf bilgisi ve gerekli yakın konuşma bağlamı işlenir. Google Gemini çevrimiçi öğretmen ve ses hizmetlerinde kullanılmaktadır. Seçilen diğer yapay zekâ özelliklerinde ilgili sağlayıcıya gereken içerik iletilebilir. Mikrofonla metne dönüştürme, işletim sisteminin konuşma hizmetine bağlıdır; çevrimdışı ders bulunması mikrofonun da her cihazda çevrimdışı çalışacağını göstermez. Gereksiz kimlik, sağlık veya üçüncü kişilere ait özel bilgileri sorulara eklemeyin."
      ]
    },
    {
      "heading": "5. Canlı ders, destek ve bildirimler",
      "paragraphs": [
        "Canlı derslerde açtığınız mikrofon, kamera, ekran paylaşımı ve sohbet, ilgili oturum katılımcılarına ve iletişimi sağlayan teknik altyapıya iletilir. Kayıt alınan bir işlem varsa amacı, kapsamı ve saklama koşulları o işlem öncesinde ayrıca açıklanmalıdır. Bu metin her oturumun kaydedildiği anlamına gelmez.",
        "Android bildirimleri için cihaz bildirim belirteci ve ilgili ders olayı Firebase Cloud Messaging altyapısında kullanılabilir. Destek talebinde yazılan iletişim ve mesaj bilgileri talebin yanıtlanması için işlenir. İletişim formu WhatsApp bağlantısı açar; hazırlanan mesajı WhatsApp içinde kullanıcı gönderir. WhatsApp ayrı bir hizmettir."
      ]
    },
    {
      "heading": "6. Toplama yöntemleri ve hukuki sebepler",
      "paragraphs": [
        "Veriler; kayıt/giriş formları, profil ve eşleştirme işlemleri, ders etkileşimleri, cihaz uygulamaları, destek kanalları ve otomatik oturum/güvenlik kayıtları yoluyla elde edilir. Teknik depolama hakkında Çerez Politikası ayrıca bilgi verir.",
        "Hizmetin zorunlu işlemlerinde sözleşmenin kurulması veya ifası; mevzuatın gerektirdiği kayıtlarda hukuki yükümlülük; uyuşmazlık kayıtlarında hakkın tesisi, kullanılması veya korunması; gerekli ve ölçülü güvenlik işlemlerinde temel hakları zedelemeyen meşru menfaat şartı değerlendirilir. Bunlardan birine dayanmayan ve rıza gerektiren işlemler için ayrı, belirli ve bilgilendirmeye dayalı açık rıza alınmalıdır. Bu sayfayı okumak, siteyi ziyaret etmek veya üye olmak tüm işlemlere rıza vermek değildir."
      ]
    },
    {
      "heading": "7. Verilerin alıcıları ve aktarım amaçları",
      "paragraphs": [
        "Hesap ve ders verileri, sunulan özellik ölçüsünde yetkilendirilmiş veli/öğretmenle; barındırma, teknik bakım, bildirim, canlı iletişim ve çevrimiçi yapay zekâ sağlayıcılarıyla işlem için gereken kapsamda paylaşılabilir. Kanunen yetkili kurumlara, geçerli yasal talepler veya yükümlülükler kapsamında bilgi aktarılabilir.",
        "Google hizmetleri, WhatsApp ve kullanılan diğer dış hizmetler yurt dışı altyapısı içerebilir. Yurt dışına aktarımda KVKK madde 9 koşullarının ayrıca karşılanması gerekir. Bu metin, geçerli bir aktarım mekanizmasının kurulduğu veya tüm sağlayıcı sözleşmelerinin tamamlandığı beyanı değildir; sağlayıcı ve aktarım envanteri işletmeci tarafından kesinleştirilmelidir."
      ]
    },
    {
      "heading": "8. Saklama ve silme",
      "paragraphs": [
        "Veriler ilgili amaç için gerekli süre ve uygulanabilir yasal yükümlülüklerle sınırlı tutulmalıdır. Test yayını için kategori bazındaki kesin saklama takvimi henüz tamamlanmamıştır. Hesap, destek, teknik güvenlik kayıtları ve yedekler aynı süreye tabi kabul edilmez. İşleme şartları ortadan kalkan veriler için silme, yok etme veya anonimleştirme değerlendirilir.",
        "Uygulamayı kaldırmak ya da tarayıcı verilerini temizlemek sunucudaki hesabı kapatmaz. Yerel ders paketi ve yerel sohbet silme işlemleri cihazı etkiler; paylaşılmış kayıtlar ayrıca değerlendirilir. Silme talebinde, hangi hesap ve kayıt grubunun kastedildiğini belirtin."
      ]
    },
    {
      "heading": "9. Haklarınız",
      "paragraphs": [
        "KVKK madde 11 kapsamında; kişisel verilerinizin işlenip işlenmediğini öğrenebilir, işlenmişse bilgi talep edebilir, işleme amacını ve amaca uygun kullanımı sorgulayabilir, yurt içindeki ve yurt dışındaki alıcıları öğrenebilirsiniz. Eksik veya yanlış kayıtların düzeltilmesini; kanuni şartları varsa silinmesini veya yok edilmesini ve bu işlemlerin alıcılara bildirilmesini isteyebilirsiniz.",
        "Yalnızca otomatik analizle aleyhinize çıkan sonuca itiraz etme ve hukuka aykırı işleme nedeniyle uğradığınız zararın giderilmesini talep etme hakkınız da vardır. Çocuğa ilişkin taleplerde yasal temsil yetkisinin doğrulanması gerekebilir."
      ]
    },
    {
      "heading": "10. Başvuru ve güncelleme",
      "paragraphs": [
        "Şu anki destek kanalı DersDinle.com İletişim sayfası ve 0552 677 95 67 numaralı WhatsApp hattıdır. Talebinizde hesapla ilişkili iletişim bilginizi ve talebinizin konusunu belirtin; şifre, tek kullanımlık kod veya gereksiz kimlik belgesi göndermeyin. WhatsApp, tek zorunlu hukuki başvuru yolu olarak sunulmamaktadır. Resmî başvuru adresi ve uygun başvuru yöntemleri tamamlandığında bu sayfaya eklenecektir.",
        "Usulüne uygun veri sorumlusu başvuruları, kanundaki şartlarla en kısa sürede ve en geç 30 gün içinde sonuçlandırılır. Başvuru ve Kurula şikâyet hakları saklıdır. Güncel resmî bilgi için Kişisel Verileri Koruma Kurumunun kvkk.gov.tr adresindeki kaynakları inceleyebilirsiniz. Son güncelleme: 30 Ekim 2026."
      ]
    }
  ]
},
  {
  "slug": "gizlilik-politikasi",
  "title": "Gizlilik Politikası",
  "sections": [
    {
      "heading": "1. Kapsam ve iletişim",
      "paragraphs": [
        "Bu politika, DersDinle.com web sitesi ile DersDinle Mobil, Meraklı Masaüstü, Meraklı Mobil ve DersDinle Toplantı uygulamalarındaki kişisel veri kullanımını açıklar. Kullanılan özelliğe ve hesap rolüne göre işlenen bilgiler değişir.",
        "DersDinle.com bu metinde platformun marka adıdır. Test yayını sürmektedir; işletmeci/veri sorumlusunun resmî kimliği ve başvuru adresi henüz bu metinde tamamlanmamıştır. İletişim sayfasından veya 0552 677 95 67 numaralı WhatsApp hattından bilgi ve destek talep edebilirsiniz."
      ]
    },
    {
      "heading": "2. Hesap ve profil bilgileri",
      "paragraphs": [
        "Kayıt sırasında ad soyad, e-posta, telefon, il, hesap rolü ve şifre bilgileri alınır. Öğrenci hesabında sınıf ve doğum tarihi; veli eşleştirmesinde eşleştirme kodu da işlenir. Hesabınızın tanınması, giriş işlemleri ve ilgili çalışma alanının sunulması için bu bilgiler kullanılır.",
        "Şifrelerinizi, doğrulama kodlarınızı ve ödeme bilgilerinizi destek mesajlarına yazmayın. Hesap güvenliğiniz için başkasının bilgilerini kullanmayın."
      ]
    },
    {
      "heading": "3. Ders çalışmaları ve veli/öğretmen erişimi",
      "paragraphs": [
        "Kullandığınız özelliğe göre dersler, sorulara verilen yanıtlar, çalışma geçmişi, sonuçlar, görevler, ders başlangıç/bitiş durumları ve uygulama etkinliği işlenebilir. Bu bilgiler çalışma alanını sunmak ve gelişimi takip etmek için kullanılır.",
        "Bağlı veli ve yetkilendirilmiş öğretmen, kendisine eşleştirilmiş veya atanmış öğrencinin ilgili bilgilerini görebilir. Meraklı denetim özelliklerinde cihaz bilgileri, uygulama adları, kullanım süreleri ve çevrimiçi durum gibi kayıtlar bulunabilir. Eşleştirme kodunu yalnızca yetkili kişiyle paylaşın; yanlış eşleştirmeyi destek kanalına bildirin."
      ]
    },
    {
      "heading": "4. Yerel hafıza, yapay zekâ ve ses",
      "paragraphs": [
        "Meraklı’nın yerel öğrenme hafızası öğrencinin cihazında tutulabilir. Bu, uygulamadaki bütün işlemlerin çevrimdışı kaldığı anlamına gelmez: hesaba bağlı gelişim özetleri, ders durumları ve denetim kayıtları sunucuya iletilebilir.",
        "Çevrimiçi yapay zekâ ve ses özelliklerinde, kullanılan özelliğe göre soru/metin, gerekli ders bağlamı, ses veya görsel verisi hizmet sağlayıcılarına aktarılabilir. Mevcut çevrimiçi öğretmen altyapısında Google Gemini hizmetleri kullanılmaktadır. Mikrofon erişimini cihaz ayarlarından yönetebilirsiniz. Yerel cihaz verisinin kaldırılması, sunucudaki hesap kayıtlarının otomatik olarak silindiği anlamına gelmez."
      ]
    },
    {
      "heading": "5. Canlı ders, bildirim ve teknik kayıtlar",
      "paragraphs": [
        "Canlı ders sırasında açtığınız kamera, mikrofon, ekran paylaşımı ve sohbet içeriği oturumun ilgili katılımcılarına iletilir. Paylaşım öncesinde ekranınızdaki özel bilgileri kapatın. Her oturumun otomatik kaydedildiği varsayılmamalıdır; kayıt özelliği kullanılan akışın ayrıca açıklanması gerekir.",
        "Bildirim özelliklerinde cihaz bildirim belirteci ve ilgili ders olayı işlenebilir; Android bildirim altyapısında Firebase Cloud Messaging kullanılır. Oturum, hata ve güvenlik kayıtları hizmetin çalışması, sorunların incelenmesi ve kötüye kullanımın önlenmesi için kullanılabilir."
      ]
    },
    {
      "heading": "6. İletişim formu ve WhatsApp",
      "paragraphs": [
        "İletişim formuna yazdığınız ad soyad, konu ve mesaj, WhatsApp bağlantısındaki hazır mesaj metnine eklenir. “WhatsApp’ta devam et” seçildiğinde bu metin WhatsApp hizmetine yönlendirilir; mesajı göndermek için WhatsApp içindeki gönderme işlemini siz yaparsınız.",
        "WhatsApp ayrı bir hizmettir ve kendi gizlilik koşulları geçerlidir. Web asistanı veya uygulama içi destek gibi diğer kanallardaki mesajlar, ilgili ekranda açıklandığı şekilde destek kayıtlarına alınabilir."
      ]
    },
    {
      "heading": "7. Amaçlar, hukuki sebepler ve hizmet sağlayıcıları",
      "paragraphs": [
        "Hesap ve hizmetin yürütülmesi için gerekli işlemler sözleşmenin kurulması/ifası; zorunlu kayıtlar hukuki yükümlülük; güvenlik ve hakların korunmasına ilişkin işlemler, şartları varsa meşru menfaat veya bir hakkın tesisi/kullanılması/korunması kapsamında değerlendirilir. Açık rıza gerektiren işlemler için ayrı ve amaca özgü rıza alınması gerekir. Bu politikayı okumak veya üye olmak, her türlü veri kullanımına açık rıza sayılmaz.",
        "Barındırma, bildirim, çevrimiçi yapay zekâ, iletişim ve canlı ders gibi hizmetlerin teknik sağlayıcıları işlem için gerekli verilere erişebilir. Kanunen yetkili mercilere, geçerli bir hukuki yükümlülük kapsamında bilgi verilebilir. Yurt dışındaki sağlayıcılarla işlem yapılması hâlinde KVKK’nın yurt dışına aktarım şartlarının ayrıca karşılanması gerekir; bu metin tek başına aktarım izni oluşturmaz."
      ]
    },
    {
      "heading": "8. Saklama, silme ve cihaz tercihleri",
      "paragraphs": [
        "Kayıtlar, ilgili hizmetin amacı ve uygulanabilir yasal saklama yükümlülükleri dikkate alınarak tutulmalıdır. Test yayını için veri kategorilerine göre kesin saklama süreleri henüz bu metinde belirlenmemiştir; süresiz saklama veya anında silme taahhüdü verilmemektedir.",
        "Hesabınızın kapatılmasını veya bilgilerinizin düzeltilmesini/silinmesini iletişim kanalından talep edebilirsiniz. Kimlik doğrulaması gerekebilir. Yasal olarak korunması gereken kayıtlar, yedekler ve cihazınızdaki yerel veriler ayrı değerlendirilir. Uygulamayı kaldırmak tek başına hesabı kapatmaz. Tarayıcı depolamasını, bildirim ve mikrofon izinlerini cihaz ayarlarınızdan yönetebilirsiniz."
      ]
    },
    {
      "heading": "9. Çocukların verileri ve güvenlik",
      "paragraphs": [
        "Çocuklara ait hesap ve eşleştirmeler, yetkili veli/yasal temsilcinin gözetimi ve gerekli hukuki şartlarla kullanılmalıdır. Veli veya öğretmen erişimi, yalnızca yetkili olunan öğrenci ve hizmet amacıyla sınırlı olmalıdır.",
        "Erişim kontrolü ve hesap doğrulaması gibi önlemler veri güvenliğini destekler; hiçbir internet hizmeti için mutlak güvenlik garanti edilemez. Yetkisiz erişim şüphenizi bildirin ve şifrenizi değiştirin."
      ]
    },
    {
      "heading": "10. Haklarınız ve güncellemeler",
      "paragraphs": [
        "KVKK kapsamında verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi isteme, amaç ve alıcıları öğrenme, eksik/yanlış verilerin düzeltilmesini, şartları varsa silinmesini veya yok edilmesini ve işlemlerin alıcılara bildirilmesini isteme haklarınız vardır. Otomatik analizle aleyhinize bir sonuç doğmasına itiraz edebilir; hukuka aykırı işleme nedeniyle zarara uğrarsanız giderilmesini talep edebilirsiniz.",
        "Başvurular için iletişim kanalımızdan yönlendirme isteyebilirsiniz. İşletmeci kimliği, resmî başvuru bilgileri, hizmet sağlayıcı envanteri ve saklama süreleri tamamlandığında politika güncellenecektir. Önemli değişiklikler ilgili sayfada duyurulur. Son güncelleme: 30 Ekim 2026."
      ]
    }
  ]
},
  {
  "slug": "kullanici-sozlesmesi",
  "title": "Kullanıcı Sözleşmesi",
  "sections": [
    {
      "heading": "1. Taraflar ve kapsam",
      "paragraphs": [
        "Bu kullanım koşulları, DersDinle.com web sitesi ve bağlantılı DersDinle Mobil, Meraklı Masaüstü, Meraklı Mobil ve DersDinle Toplantı uygulamalarından yararlanan kullanıcıların hak ve sorumluluklarını açıklar. DersDinle.com bu metinde platformun marka adıdır; işletmecinin resmî kimlik ve adres bilgileri test sürecinde tamamlanacaktır.",
        "Üyelik veya hizmet kullanımı öncesinde koşulları okuyun. Gizlilik Politikası kişisel veri kullanımını ayrıca açıklar; bu sözleşmenin kabulü, ayrı açık rıza gerektiren işlemlerin yerine geçmez."
      ]
    },
    {
      "heading": "2. Test yayını ve hizmetin niteliği",
      "paragraphs": [
        "Web sitesi ve uygulamalar test aşamasındadır. İçerikler, ekranlar ve özellikler değişebilir; bakım, hata veya teknik bağımlılıklar nedeniyle geçici kesinti yaşanabilir. Test yayını ibaresi, kanundan doğan kullanıcı ve tüketici haklarını ortadan kaldırmaz.",
        "DersDinle.com öğrenmeye destek sunar. Belirli not, sınav sonucu veya başarı garantisi verilmez. Yapay zekâ yanıtları hatalı olabilir; önemli bilgileri öğretmeniniz ve güvenilir kaynaklarla kontrol edin."
      ]
    },
    {
      "heading": "3. Hesap açma ve hesap güvenliği",
      "paragraphs": [
        "Kullanıcı, doğru ve güncel bilgilerle kendi hesabını oluşturmalıdır. Başkasının kimliğiyle hesap açmak, yetkisiz hesap paylaşmak ve güvenlik önlemlerini aşmak yasaktır. Şifre ve doğrulama kodları gizli tutulmalıdır.",
        "Öğrenci ve veli hesapları farklı işlevlere sahiptir. Giriş ekranındaki rol seçimi yetki kazandırmaz; erişim hesapta tanımlı role göre belirlenir. Çocukların üyeliği ve kullanımı, gerekli hâllerde veli/yasal temsilci onayı ve gözetimiyle yürütülmelidir."
      ]
    },
    {
      "heading": "4. Veli eşleştirmesi ve öğretmen erişimi",
      "paragraphs": [
        "Veli yalnızca temsil yetkisine sahip olduğu öğrenciyle eşleşmelidir. Öğretmen, kendisine atanmış öğrenciler için yetkilendirilmiş alanları kullanmalıdır. Eşleştirme kodları ve davet bağlantıları yetkisiz kişilerle paylaşılmamalıdır.",
        "Veli takibindeki kullanım süreleri ve cihaz durumları bağlantı kesintisi veya eşitleme gecikmesinden etkilenebilir. Çevrimdışı cihaz bilgisi canlı durum olarak yorumlanmamalıdır. Veli denetimi özellikleri güvenli ve ölçülü biçimde kullanılmalıdır."
      ]
    },
    {
      "heading": "5. Uygulamalar ve canlı dersler",
      "paragraphs": [
        "Uygulamalar, ilgili indirme sayfasında belirtilen işletim sistemi ve teknik gereksinimlerle kullanılmalıdır. Çevrimiçi hizmetler internet bağlantısına ve gerektiğinde mikrofon, kamera veya bildirim izinlerine bağlıdır.",
        "Canlı derslerde diğer katılımcıların haklarına saygı gösterin. Yetkisiz kayıt, görüntü/ses paylaşımı ve davet bağlantısını amacı dışında yayma yasaktır. Öğrenci ataması ve misafir davetleri ilgili dersin erişim kurallarına tabidir."
      ]
    },
    {
      "heading": "6. İçerikler ve kabul edilebilir kullanım",
      "paragraphs": [
        "Platform içerikleri, yazılım, logo ve tasarımlar üzerindeki haklar sahiplerine aittir. Açıkça izin verilen kullanım dışında içerikleri çoğaltmak, satmak, topluca çekmek veya dağıtmak yasaktır. Kanunun izin verdiği kullanımlar saklıdır.",
        "Yüklediğiniz soru, görsel ve mesaj için gerekli hak ve yetkilere sahip olmalısınız. Başkalarının kişisel verilerini, zararlı yazılımı, hukuka aykırı veya hakaret içeren içerikleri paylaşmayın. Güvenliği bozacak, hizmeti engelleyecek veya hesaplara izinsiz erişecek faaliyetlerde bulunmayın."
      ]
    },
    {
      "heading": "7. Ücretsiz üyelik ve ücretli hizmetler",
      "paragraphs": [
        "Ücretsiz hesap açılması, bütün özelliklerin ve uygulamaların sınırsız olarak ücretsiz olduğu anlamına gelmez. Erişim kapsamı ilgili paket ve hesap ekranında belirtilir. Test dönemindeki bir özelliğin ileride ücretli sunulması, kendiliğinden ödeme yükümlülüğü doğurmaz.",
        "Ücretli işlem öncesinde toplam fiyat, süre, kapsam ve varsa yenileme bilgileri ayrıca gösterilmelidir. Satın alma işlemlerinde uygulanabilir ön bilgilendirme, mesafeli sözleşme, cayma ve iade hakları saklıdır; bu genel koşullar yasal haklardan feragat anlamına gelmez."
      ]
    },
    {
      "heading": "8. Hesabın sınırlandırılması ve kapatılması",
      "paragraphs": [
        "Güvenlik riski, yetkisiz erişim veya koşulların ihlali hâlinde ilgili erişim, gerekli ve ölçülü biçimde sınırlandırılabilir. Mümkün olduğunda kullanıcıya gerekçe ve destek kanalı bildirilir.",
        "Hesabınızı kapatmak için iletişim kanalından talepte bulunabilirsiniz. Kapatmanın ücretli hizmetlere ve veri kayıtlarına etkisi, ilgili hizmet koşulları ve yasal yükümlülüklere göre değerlendirilir. Uygulamayı kaldırmak hesap kapatma talebi yerine geçmez."
      ]
    },
    {
      "heading": "9. Sorumluluk ve üçüncü taraf hizmetler",
      "paragraphs": [
        "Bağlantı, cihaz veya üçüncü taraf hizmet kaynaklı kesintiler kullanım deneyimini etkileyebilir. Kullanıcı, önemli çalışmalarının uygun yedeklerini saklamalıdır. Platformun kanunen bertaraf edilemeyecek sorumlulukları, ağır kusuru ve tüketicinin zorunlu hakları bu metinle sınırlandırılmaz.",
        "WhatsApp, bildirim ve çevrimiçi yapay zekâ gibi dış hizmetler kendi koşullarına da tabidir. Kişisel verilerin bu hizmetlerle ilişkisi Gizlilik Politikası’nda açıklanır."
      ]
    },
    {
      "heading": "10. İletişim, değişiklikler ve uyuşmazlıklar",
      "paragraphs": [
        "Sorularınızı ve taleplerinizi İletişim sayfasından veya 0552 677 95 67 numaralı WhatsApp hattından iletebilirsiniz. Mesaj gönderirken şifre ve doğrulama kodu paylaşmayın.",
        "Koşullar güncellendiğinde tarih bu sayfada değiştirilir; önemli değişiklikler duyurulur. Değişiklikler kazanılmış hakları ve zorunlu yasal korumaları ortadan kaldırmaz. Türk hukuku uygulanır; uyuşmazlıklarda kanunen yetkili mahkemelere ve şartları varsa tüketici hakem heyetlerine başvuru hakları saklıdır. Son güncelleme: 30 Ekim 2026."
      ]
    }
  ]
},
{
  "slug": "cerez-politikasi",
  "title": "Çerez Politikası",
  "sections": [
    {
      "heading": "1. Bu politika neyi açıklar?",
      "paragraphs": [
        "DersDinle.com’da oturumun korunması ve ders ekranlarının çalışması için kullanılan çerezleri ve benzer tarayıcı depolamasını açıklar. Çerezler tarayıcının sakladığı küçük kayıtlardır. sessionStorage gibi depolama alanları teknik olarak çerez değildir; kullanıcıya etkisi benzer olduğundan burada ayrıca açıklanır.",
        "Bu metinde DersDinle.com platformun marka adıdır. İşletmeci/veri sorumlusunun resmî kimlik ve başvuru bilgileri test sürecinde tamamlanacaktır. Kişisel veri işlemenin genel kapsamı için KVKK Aydınlatma Metni ve Gizlilik Politikası’nı da okuyun."
      ]
    },
    {
      "heading": "2. Giriş çerezi: dd_session",
      "paragraphs": [
        "Birinci taraf dd_session çerezi, giriş yapmış kullanıcının sunucudaki oturum kaydıyla eşleştirilmesi için kullanılır. Rastgele bir oturum belirteci içerir; çerezin içine şifre veya ders yanıtları yazılmaz. Hesap alanları ve yetkili işlemler için gereklidir. Hukuki değerlendirme, talep edilen hesap hizmetinin kurulması/ifası ve gerekli güvenlik işlemleriyle bağlantılıdır.",
        "Web girişinde tanımlanan süre 14 gündür. Çıkış işleminde çerez kaldırılır; sunucu tarafında iptal veya süre sonu oluşursa çerez bulunsa da oturum geçersiz olabilir. Çerez HttpOnly ve SameSite=Lax nitelikleriyle oluşturulur; üretim yapılandırması HTTPS için Secure niteliğini kullanır. Oturum belirtecinizi başkalarıyla paylaşmayın."
      ]
    },
    {
      "heading": "3. Ders ekranlarında sekme depolaması",
      "paragraphs": [
        "Soru çözme ekranı, dd_question_test:v2: ile başlayan sessionStorage anahtarlarında devam eden testin sorularını, yanıtlarını, konumunu ve zaman bilgilerini geçici olarak saklayabilir. Amaç aynı sekmede sayfa yenilendiğinde çalışmayı sürdürmektir. Tamamlanma akışında ilgili kayıt kaldırılır. Son deneme sonucunu gösteren ekran dd_son_deneme anahtarını okuyabilir.",
        "sessionStorage aynı site ve sekme bağlamına bağlıdır; normalde sekme oturumu bittiğinde temizlenir. Tarayıcının oturumu geri yükleme davranışı farklı olabilir. Bu alandaki veriler her HTTP isteğinde çerez gibi otomatik gönderilmez; sonuç gönderimi uygulamanın ilgili işleminde ayrıca yapılır. Ortak cihazda işiniz bittiğinde çıkış yapın ve gerekirse site verilerini temizleyin."
      ]
    },
    {
      "heading": "4. Analitik, reklam ve tercih çerezleri",
      "paragraphs": [
        "İncelenen mevcut ön yüz uygulamasında reklam veya ziyaretçi analitiği için etkin bir üçüncü taraf çerez entegrasyonu doğrulanmamıştır. Yönetim ekranında bir analitik ayarının bulunması tek başına takip kodunun çalıştığı anlamına gelmez. Bu nedenle burada kullanılmayan reklam çerezleri veya olmayan bir çerez tercih paneli varmış gibi gösterilmez.",
        "İleride zorunlu olmayan izleme veya reklam araçları eklenirse amaç, sağlayıcı ve süreleri kullanımdan önce açıklanmalı; açık rıza dışında geçerli işleme şartı bulunmayan araçlar tercih alınmadan çalıştırılmamalıdır. Rıza vermemek ve verilen rızayı geri almak mümkün olmalıdır. Siteyi kullanmaya devam etmek tek başına rıza sayılmaz."
      ]
    },
    {
      "heading": "5. Dış kaynaklar ve bağlantılar",
      "paragraphs": [
        "Sitedeki bazı görseller, tanıtım filmi ve teknik kaynaklar dış alan adlarından yüklenebilir. Böyle bir dosya istendiğinde ilgili sağlayıcı IP adresi ve istekle iletilen teknik bilgileri alabilir. Dış kaynaktan dosya yüklenmesi ile tarayıcıya çerez yerleştirilmesi farklı işlemlerdir; her dış kaynağın çerez bıraktığı varsayılmaz.",
        "WhatsApp’a veya diğer dış sitelere geçtiğinizde o hizmetin çerez ve gizlilik koşulları devreye girer. DersDinle.com bu hizmetlerin tarayıcı depolamasını kendi tercih ekranından yönetmez. Üçüncü taraf kaynakların teknik davranışı hizmet güncellemeleriyle değişebileceğinden envanterin izlenmesi gerekir."
      ]
    },
    {
      "heading": "6. Çerezleri ve site verilerini nasıl yönetebilirsiniz?",
      "paragraphs": [
        "Tarayıcınızın Ayarlar bölümünde Gizlilik/Güvenlik, Çerezler veya Site verileri başlıklarını açarak dersdinle.com kayıtlarını inceleyebilir ve silebilirsiniz. Menü adları tarayıcıya göre değişir. Üçüncü taraf çerezlerini ayrıca engelleyebilirsiniz.",
        "dd_session silinirse tekrar giriş yapmanız gerekir. Sekme depolamasını temizlemek devam eden testin yerel ilerlemesini kaldırabilir. Çerezleri engellemek bazı hesap işlevlerini durdurabilir. Bu işlem sunucudaki hesap ve ders kayıtlarını otomatik silmez; hesap verilerine ilişkin talepler ayrı değerlendirilir."
      ]
    },
    {
      "heading": "7. Mobil uygulama depolaması farklıdır",
      "paragraphs": [
        "Android uygulamasındaki oturum bilgisi, yerel ders paketleri ve sohbet hafızası tarayıcı çerezi değildir. Mobil uygulamada uzun süreli oturum seçeneği ve cihazdaki güvenli oturum saklama mekanizması kullanılır; web çerezinin 14 günlük süresi uygulamadaki tüm kayıtların süresi anlamına gelmez.",
        "Telefonun uygulama verilerini temizlemek veya uygulamayı kaldırmak yerel kayıtları etkileyebilir. Bildirim, mikrofon ve uygulama kullanım izinleri cihaz ayarlarından yönetilir. Bu izinler için kullanılan işletim sistemi ekranı bir web çerez tercih paneli değildir."
      ]
    },
    {
      "heading": "8. Haklar, iletişim ve güncellik",
      "paragraphs": [
        "Çerez ve benzer teknolojilerle işlenen kişisel verileriniz hakkında KVKK Aydınlatma Metni’ndeki haklarınızı kullanabilirsiniz. İletişim sayfası veya 0552 677 95 67 numaralı WhatsApp hattı üzerinden destek ve başvuru yöntemleri hakkında bilgi isteyebilirsiniz. Resmî veri sorumlusu bilgileri tamamlandığında bu metin de güncellenecektir.",
        "Bu envanter mevcut kaynak kodundaki doğrulanabilen uygulama davranışına dayanır; kullanıcıya, tarayıcıya veya barındırma altyapısına göre ilave teknik kayıtlar bulunabilir. Yeni teknolojiler eklenirken politika ve gerekli tercih mekanizmaları birlikte güncellenmelidir. Son güncelleme: 30 Ekim 2026."
      ]
    }
  ]
},
];